import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAdminPositions } from './api';

export const path = '/hierarchy';

const PageHierarchyDiagram: React.FC = (props) => {
  const HierarchyDiagram = Loadable.Map({
    loader: {
      page: () => import('./page'),
      adminPositions: getAdminPositions,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <HierarchyDiagram {...props} />;
};

export default PageHierarchyDiagram;
